var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"payment-detail-header tw-text-center tw-flex tw-items-center tw-justify-between tw-px-3 tw-shadow-md tw-z-10 tw-h-10"},[_c('div'),(_vm.getCurrentPayment)?_c('div',{domProps:{"textContent":_vm._s(_vm.$t('billing.payment_title', {
      ref: _vm.getCurrentPayment.reference
    }))}}):_vm._e(),_c('payment-detail-header-close-button',{attrs:{"to":_vm.to}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }